<template>
  <v-app light>
    <!-- home nav drawer -->
    <v-navigation-drawer v-model="drawer" fixed clipped app>
      <v-list dense>
        <template>
          <!-- <v-list-group prepend-icon="feedback">
            <v-list-tile slot="activator">
              <v-list-tile-title>Feedback</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="$router.push('/feedback')">
              <v-list-tile-title>Feedback</v-list-tile-title>
            </v-list-tile>
          </v-list-group>
          <v-divider></v-divider> -->
          <v-list-tile @click="$router.push('/customerportal/feedback')">
            <v-list-tile-action>
              <v-icon>feedback</v-icon>
            </v-list-tile-action>
            <v-list-tile-title>Feedback</v-list-tile-title>
          </v-list-tile>
          <v-divider></v-divider>
          <!-- REPORTS -->
          <v-list-group prepend-icon="timeline">
            <v-list-tile slot="activator">
              <v-list-tile-title>Reports</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="$router.push('/customerportal/report/summary')">
              <v-list-tile-title>Report Summary</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="$router.push('/customerportal/report/dashboard')">
              <v-list-tile-title>Detailed Report</v-list-tile-title>
            </v-list-tile>
            <!-- <v-list-tile @click="$router.push('/customerportal/report/supervisor-tasks')">
              <v-list-tile-title>Supervisor Tasks</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="$router.push('/customerportal/report/ops-manager-tasks-report')">
              <v-list-tile-title>Ops Manager Tasks</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="$router.push('/customerportal/report/ops-manager-visits')">
              <v-list-tile-title>Ops Manager Visits</v-list-tile-title>
            </v-list-tile> -->
          </v-list-group>
          <v-divider></v-divider>
        </template>
      </v-list>
    </v-navigation-drawer>
    <!-- <v-spacer></v-spacer> -->
    <v-toolbar dense color="primary" app clipped-left>
      <v-toolbar-side-icon @click="drawer = !drawer"></v-toolbar-side-icon>
      <span class="title ml-3 mr-5">SuburbanServ</span>
      <v-spacer></v-spacer>
      <v-btn flat dark @click="logout()">
        <v-icon>exit_to_app</v-icon>Logout
      </v-btn>
    </v-toolbar>
    <v-content>
      <router-view />
    </v-content>

    <v-footer app inset fixed>
      <v-spacer></v-spacer>
      <div class="hidden-sm-and-down">Powered by DevInspire (Pty) Ltd. &copy; {{ new Date().getFullYear() }}</div>
    </v-footer>
  </v-app>
</template>

<script>
  import JWT from "jsonwebtoken";

  export default {
    data() {
      let self = this;
      return {
        drawer: null,
        items: []
      };
    },
    mounted() {
      let self = this;

    },
    methods: {
      routeTo(item) {
        let self = this;
        self.$router.push(item.route);
      },
      logout() {
        let self = this;
        self.$router.push("/login");
      },
    },
    props: {
      source: String
    }
  };
</script>

<style>
</style>